import { GENEALOGY_REPORT_LIST_TABLE_HEADERS as HEADERS } from "../../../../constants/analyticsGenealogy";

import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Paper,
  Chip,
  Grid,
  Divider,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Button,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";

import "./genealogyListTable.scss";
import Label from "../../../../components/Label/Label";
import CAMHeader from "../../../../components/Header/CAMHeader";
import CAMDrawer from "../../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../../components/contsiners/InvestigatorContainer";
import TabsBar from "../../header/TabsNav";
import BreadcrumbsBar from "../../header/BreadcrumbNav";
import { fetchGenealogyReports } from "../../../../redux/genealogy/actions";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import Pagination from "../../../../components/Pagination";
import { hasPermission } from "../../../../utils/permissions";
import {
  GENEALOGY_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../../constants/permissions";
import ApplicationStatusChip from "../../../../components/StatusChip/ApplicationStatusChip";
import {
  APPLICATION_STATUS_CHIP_SX,
  getApplicationStatusStyle,
} from "../../../../constants/statusStyles";

const tableCellSx = {
  padding: "8px 12px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  verticalAlign: "middle",
};

const StatusChip = ({ status }) => {
  const label = status
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  if (getApplicationStatusStyle(status)) {
    return <ApplicationStatusChip status={status} label={label} />;
  }

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        ...APPLICATION_STATUS_CHIP_SX,
        backgroundColor: status === "Saved" ? "#C9F6CF" : "#F1FFC5",
        color: "#1f2937",
      }}
    />
  );
};

const Row = ({ index, row, handleMenuClick, data, hasAction }) => {
  return (
    <TableRow hover>
      <TableCell>{data?.page_size * (data?.page - 1) + index + 1}</TableCell>
      <TableCell sx={{ ...tableCellSx, width: "40%" }}>
        <Label text={row?.report_name} fontSize={14} fontWeight={500} />
      </TableCell>

      <TableCell sx={tableCellSx}>
        <Label text={row?.updated_at} />
      </TableCell>

      <TableCell sx={tableCellSx}>
        <Label text={row?.created_by} />
      </TableCell>

      <TableCell sx={tableCellSx}>
        <StatusChip status={row?.status} />
      </TableCell>

      <TableCell sx={tableCellSx}>
        <IconButton
          size="small"
          onClick={(e) => handleMenuClick(e, row)}
          disabled={!hasAction}
        >
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

const GenealogyReportListTable = () => {
  const canCreateReport = hasPermission(PERMISSION_MODULES.GENEALOGY, GENEALOGY_PERMISSIONS.CREATE_NEW_REPORT);
  const canEditDraft = hasPermission(PERMISSION_MODULES.GENEALOGY, GENEALOGY_PERMISSIONS.EDIT_DRAFT_REPORT);
  const canViewSavedReport = hasPermission(PERMISSION_MODULES.GENEALOGY, GENEALOGY_PERMISSIONS.VIEW_SAVED_REPORT);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const genealogyList = useSelector((state) => state?.genealogy?.genealogyList);

  const { loader, apiError, message, data = {} } = genealogyList || {};

  const rows = data?.results || [];
  const totalPages = data?.total_pages || 1;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [reportName, setReportName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);

  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(
      fetchGenealogyReports({
        report_name: reportName,
        status: statusFilter,
        page: page,
      }),
    );
  }, [page]);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleView = (row) => {
    const isDraft = row?.status === "Draft";
    if (isDraft ? !canEditDraft : !canViewSavedReport) return;
    handleMenuClose();

    // navigate(`/analytics/genealogy/view`, {
    navigate(`/genealogy/view`, {
      state: {
        report_id: row?.id,
        mode: "view",
        status: row?.status,
      },
    });
  };

  // if (loader) {
  //   return (
  //     <Box py={6} display="flex" justifyContent="center">
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // if (apiError) {
  //   return (
  //     <Box py={6} display="flex" justifyContent="center">
  //       <Typography color="error">{message}</Typography>
  //     </Box>
  //   );
  // }

  // if (!data?.length) {
  //   return (
  //     <Box py={6} textAlign="center">
  //       <Label text="No Records found." />
  //     </Box>
  //   );
  // }

  const handleSearch = () => {
    setPage(1);
    dispatch(
      fetchGenealogyReports({
        report_name: reportName,
        status: statusFilter,
        page: 1,
      }),
    );
  };

  const handleCreateReport = () => {
    if (!canCreateReport) return;
    navigate("/genealogy/create");
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleReset = () => {
    setReportName("");
    setStatusFilter("");
    setPage(1);

    dispatch(
      fetchGenealogyReports({
        report_name: "",
        status: "",
        page: 1,
      }),
    );
  };

  return (
    <div>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        {/* <DropdownsBar /> */}
        {/* <Grid container alignItems="center" spacing={2}>
          //  Tabs 
          <Grid item xs={12} md={12} sx={{ pr: { md: 0 } }}>
            <TabsBar />
          </Grid>
        </Grid> */}

        {/* <Divider sx={{ mx: 2 }} /> */}
        <Grid item xs={12} md={12} sx={{ pr: { md: 0 } }}>
          <BreadcrumbsBar />
        </Grid>
        <Divider sx={{ mx: 2 }} />

        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          px={2}
          py={1}
          gap={1} // spacing between all fields
        >
          <TextField
            label="Search"
            variant="outlined"
            size="small"
            value={reportName}
            onChange={(e) => setReportName(e.target.value)}
            sx={{ width: 180 }}
          />

          <FormControl size="small" sx={{ width: 100 }}>
            <InputLabel shrink>Status</InputLabel>

            <Select
              value={statusFilter}
              label="Status"
              displayEmpty
              onChange={(e) => setStatusFilter(e.target.value)}
              renderValue={(selected) => {
                if (!selected) {
                  return <span style={{ color: "#9e9e9e" }}>All</span>;
                }
                return selected;
              }}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              <MenuItem value="Saved">Saved</MenuItem>
              <MenuItem value="Draft">Draft</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSearch()}
            sx={{ textTransform: "none", minWidth: 90 }}
          >
            <Label text="Search" color="inherit" />
          </Button>

          <Button
            variant="outlined"
            onClick={handleReset}
            sx={{ textTransform: "none", minWidth: 90 }}
          >
            <Label text="Reset" />
          </Button>

          {/* <Button
            variant="outlined"
            color="primary"
            sx={{ textTransform: "none", minWidth: 110 }}
          >
            <Label text="Audit Trail" color="inherit" />
          </Button> */}

          {canCreateReport && <Button
            variant="contained"
            onClick={handleCreateReport}
            sx={{ textTransform: "none" }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <AddIcon />
              <Label text="Create New Report" color="inherit" />
            </Box>
          </Button>}
        </Box>
        <Divider sx={{ mx: 2 }} />

        <Box className="genealogy-table-wrapper">
          <TableContainer className="genealogy-table-scroll">
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ background: "#E9E9E9" }}>
                  {HEADERS.map((h, i) => (
                    <TableCell key={i} className="table-header-cell">
                      <Label text={h} fontSize="14px" fontWeight="700" />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {rows?.map((row, index) => (
                  <Row
                    index={index}
                    row={row}
                    data={data}
                    handleMenuClick={handleMenuClick}
                    hasAction={row?.status === "Draft" ? canEditDraft : canViewSavedReport}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
          <MenuItem onClick={() => handleView(selectedRow)}>
            <Label text={selectedRow?.status === "Draft" ? "Edit" : "View"} />
          </MenuItem>
        </Menu>

        <Box className="viz-list-pagination">
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        </Box>
      </InvestigatorContainer>
    </div>
  );
};

export default GenealogyReportListTable;
